import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-gray-400 bg-opacity-50 flex fixed w-full h-screen items-center justify-center",
  style: { top: '0px', left: '0px' }
}
const _hoisted_2 = { class: "flex flex-col modal-box w-96" }
const _hoisted_3 = { class: "flex justify-end w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 11L11 1",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11 11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-col gap-4 p-2 w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Edit Category")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "button" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Update")
], -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "modal-button-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-field w-full",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.categoryName) = $event))
        }, null, 512), [
          [_vModelText, _ctx.categoryName]
        ]),
        _createElementVNode("div", {
          class: "flex justify-end",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
        }, _hoisted_9)
      ])
    ])
  ]))
}